import { style } from '@vanilla-extract/css';

const host = style({
  width: '100vw',
  height: '100vh',
});

const embedded = style({
  width: '100%',
  height: '100%',
});

const logo = style({
  selectors: {
    [`${embedded} &`]: {
      display: 'none',
    },
  },
});

const description = style({
  maxWidth: '50rem',
});

export const css = {
  host,
  embedded,
  logo,
  description,
};
